// extracted by mini-css-extract-plugin
export var formContainer = "_gk-0";
export var message = "_gk-1";